function open_dialog() {
  let sizeDialog = document.getElementById('size-guide-dialog')
  sizeDialog.showModal();
  document.body.classList.add('overflow-hidden');
  sizeDialog.querySelector('size-guide-table').fetchTables();
}

function close_dialog() {
  document.getElementById('size-guide-dialog').close();
  document.body.classList.remove('overflow-hidden');
}

function clicked_dialog_content(e) {
  // Prevent clicks anywhere on the dialog but not the curtain from closing it
  e.stopPropagation();
}

class SizeGuideTable extends HTMLElement {
  constructor() {
    super();
  }

  fetchTables() {
    if (this.classList.contains('loaded')) {
      return;
    }
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(content => {
        const html = document.createElement('div');
        html.innerHTML = content;
        let sizeGuides;
        if (this.dataset.sizeGuides) {
          let displayTables = this.dataset.sizeGuides.split(',');
          displayTables.forEach(table => {
            let tableHtml = html.querySelector(`details[data-content-handle='${table}']`);
            if (tableHtml) {
              if (!sizeGuides) {
                sizeGuides = document.createElement('div');
              }
              sizeGuides.appendChild(tableHtml);
            }
          });

        } else {
           sizeGuides = html.querySelector('#SizeGuides');
        }
        if (sizeGuides && sizeGuides.innerHTML.trim().length) {
          this.innerHTML = sizeGuides.innerHTML;
        }
        this.classList.add('loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }

}

customElements.define('size-guide-table', SizeGuideTable);

class FostrSizeGuide extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.units_container input[type=radio]').forEach(radio => {
      radio.addEventListener('change', this.toggleUnits);
    });
  }

  toggleUnits(e) {
    let tables = e.target.closest(  'fostr-size-guide').querySelectorAll('group')
    let currentUnits = e.target.value;
    let tableToShow = e.target.closest('fostr-size-guide').querySelector(`group[data-units=${currentUnits}]`);

    console.log(tables, currentUnits);
    tables.forEach(table => {
      table.setAttribute("hidden", true);
    });

    tableToShow.removeAttribute("hidden");

  }
}
customElements.define('fostr-size-guide', FostrSizeGuide);
